import React from "react";

const MAP = {
  GENUINE:    { bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-500" },
  SUSPICIOUS: { bg: "bg-amber-100",   text: "text-amber-900",   border: "border-amber-500" },
  LIKELY_FAKE:{ bg: "bg-red-100",     text: "text-red-900",     border: "border-red-500" },
  UNAVAILABLE:{ bg: "bg-zinc-100",    text: "text-zinc-800",    border: "border-zinc-400" },
};

export default function VerdictBadge({ verdict, size = "md", ...rest }) {
  const c = MAP[verdict] || MAP.UNAVAILABLE;
  const sz = size === "lg" ? "text-base px-3 py-1.5" : "text-xs px-2 py-1";
  return (
    <span
      className={`inline-flex items-center font-mono uppercase tracking-[0.15em] font-bold rounded-sm border ${c.bg} ${c.text} ${c.border} ${sz}`}
      {...rest}
    >
      {verdict?.replace("_", " ") || "N/A"}
    </span>
  );
}
